import * as React from 'react';
import { Link as PolarisLink } from '@amzn/awsui-components-react-v3';
import { LinkProps as PolarisLinkProps } from '@amzn/awsui-components-react-v3';
import { useHistory } from 'react-router-dom';
// TODO: upgrade react-router-dom to version 6 or 7, then replace useHistory with useNavigate

/*
A custom Link component so we can use react-router-dom with
Polaris/Cloudscape's Link component. Capture the `to` (react-router-dom)
or `href` (polaris/cloudscape) prop, create a handler, and pass
through the remaining props

Refer to: https://sage.amazon.dev/posts/1082478
*/
export const Link = (props: PolarisLinkProps) => {
  // if href not provided, we are assuming onFollow is already implemented for that link.
  if (!props.href) {
    return <PolarisLink {...props} />;
  }
  // for links that should reload the page, use simple Polaris link
  if (props.href.startsWith('http') || !!props.external) {
    const polarisProps = props as PolarisLinkProps;
    return <PolarisLink {...polarisProps} />;
  }
  // to navigate using react-router-dom without reloading the page, use the override
  return <ReactRouterDomLinkOverride {...props} />;
};

const ReactRouterDomLinkOverride = (props: PolarisLinkProps) => {
  // Capture to, color, onClick as they mismatch with cloudscape Link props
  const history = useHistory();
  const displayURL = `${window.location.origin}${props.href}`;
  const handleClick = (event: any) => {
    event.preventDefault();
    history.push(props.href);
  };
  return <PolarisLink {...props} href={displayURL} onFollow={handleClick} />;
};
